export default "__VITE_PUBLIC_ASSET__1904cd1a__"